import { AxiosRequestConfig } from "axios";
import CONFIG from "../config";


const requestInterceptor = (config: any) => {

    // Customer ID add to header
    const customerId = CONFIG.CUSTOMER_ID;
    if (customerId) {

        config.headers!["X-CID"] = customerId;
    }
    return config;
};

export {
    requestInterceptor
}